import api from "../services/api";
import { offlineDB } from "../offline/db";

/**
 * Get stock from IndexedDB (OFFLINE)
 */

export const checkOfflineStock = async (branch_id, items) => {
  const inventory = await offlineDB.inventory.toArray();

  const issues = [];

  items.forEach(item => {
    const record = inventory.find(
      i =>
        i.product_id === item.product_id &&
        i.branch_id === branch_id
    );

    if (!record || record.quantity < item.quantity) {
      issues.push({
        product_id: item.product_id,
        available: record?.quantity || 0,
        requested: item.quantity
      });
    }
  });

  if (issues.length > 0) {
    throw {
      error: "INSUFFICIENT_STOCK",
      issues
    };
  }

  return true;
};


export const getOfflineStockMap = async (branchId) => {
  if (!branchId || typeof branchId !== "number") {
    console.error("❌ Invalid branchId:", branchId);
    return {};
  }

  const inventory = await offlineDB.inventory
    .where("branch_id")
    .equals(branchId)
    .toArray();

  const map = {};

  inventory.forEach(i => {
    map[i.product_id] = i.quantity;
  });

  return map;
};



/**
 * Sync products & inventory from server → IndexedDB (ONLINE)
 */
export const syncStockToLocal = async () => {
  if (!navigator.onLine) return;

  try {
    const [productsRes, inventoryRes] = await Promise.all([
      api.get("/products"),
      api.get("/inventory")
    ]);

    await offlineDB.products.clear();
    await offlineDB.inventory.clear();

    await offlineDB.products.bulkAdd(productsRes.data);
    await offlineDB.inventory.bulkAdd(inventoryRes.data);

    console.log("✅ Offline stock synced");
  } catch (err) {
    console.error("❌ Offline sync failed", err);
  }
};
